import classNames from 'classnames';
import styles from './EmphasizedContentCard.module.scss';
import { Heading, Picture, Container, RichText, VideoConsent } from 'ui/components';
import { LinkButtonFeature } from 'features/Modules/Linkbutton';

export interface EmphasizedContentCardProps {
    className?: string;
    image: any | null;
    video?: string;
    cTALink?: {
        url: string;
        name?: string;
        target?: string;
    };
    cTASecondaryLink?: {
        url: string;
        name?: string;
        target?: string;
    };
    heading?: string;
    text?: string;
    backgroundColor?: string;

    orientation: 'Vertical' | 'Block' | '';
}

export const EmphasizedContentCard: React.FC<EmphasizedContentCardProps> = ({
    className,
    image,
    video,
    cTALink,
    cTASecondaryLink,
    heading,
    text,
    backgroundColor,
    orientation,
}) => {
    const hasMedia = Boolean(image || video);

    const hexColorPattern = /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/;

    const validBackgroundColor =
        backgroundColor && hexColorPattern.test(backgroundColor.trim())
            ? backgroundColor.trim()
            : undefined;

    const backgroundStyle = validBackgroundColor
        ? ({
            '--bg-color': validBackgroundColor,
        } as React.CSSProperties)
        : undefined;


    const contentImage = image && (
        <div className={styles.EmphasizedContentCard_media}>
            <span className={styles.EmphasizedContentCard_mediabox}>
                <Picture
                    aspectRatio={0.5625}
                    url={image?.url}
                    altText={image?.altText}
                    focalPoint={image?.focalPoint}
                    sizes="100vw"
                    className={video ? styles.EmphasizedContentCard_mediabox___picture : ''}
                />
            </span>
        </div>
    );

    const contentVideo = (
        <VideoConsent
            className={classNames(
                styles.EmphasizedContentCard_media,
                styles.EmphasizedContentCard_media___videoOnly
            )}
            video={video}
        />
    );

    const contentInfoBox = (
        <div className={styles.EmphasizedContentCard_box}>
            <div className={styles.EmphasizedContentCard_textbox}>
                {heading && (
                    <Heading
                        className={styles.EmphasizedContentCard_heading}
                        style="lg"
                        headingLevel="h2"
                    >
                        {heading}
                    </Heading>
                )}

                <div className={styles.EmphasizedContentCard_textcontent}>
                    <RichText
                        className={styles.EmphasizedContentCard_text}
                        content={text}
                    />

                    <div className={styles.EmphasizedContentCard_LinkBox}>
                        {cTALink && (
                            <LinkButtonFeature
                                ariaLabel={cTALink.name}
                                {...cTALink}
                                className={styles.EmphasizedContentCard_button}
                                style="primary"
                            >
                                {cTALink.name}
                            </LinkButtonFeature>
                        )}

                        {cTASecondaryLink && (
                            <LinkButtonFeature
                                ariaLabel={cTASecondaryLink.name}
                                {...cTASecondaryLink}
                                className={styles.EmphasizedContentCard_button}
                                style="secondary"
                            >
                                {cTASecondaryLink.name}
                            </LinkButtonFeature>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );

    const content = (
        <>
            {image && contentImage}

            {video && !image && contentVideo}

            {contentInfoBox}
        </>
    );

    return (
        <Container width="Standard">
            <div
                style={backgroundStyle}
                className={classNames(
                    styles.EmphasizedContentCard,
                    {
                        [styles.EmphasizedContentCard___rowBlock]:
                            orientation === 'Block',
                    },
                    {
                        [styles.EmphasizedContentCard___noMedia]:
                            !hasMedia
                    },
                    className
                )}
            >
                {content}
            </div>
        </Container>
    );
};